// extracted by mini-css-extract-plugin
export default {"popupContainer":"Modal_popupContainer__YKDx-"};